import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface BoxplotChartProps {
  categories: string[];
  data: number[][];
  height?: number | string;
  loading?: boolean;
}

export function BoxplotChart({ categories, data, height, loading }: BoxplotChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'category', data: categories },
    yAxis: { type: 'value' },
    series: [
      { name: 'boxplot', type: 'boxplot', data, itemStyle: { color: '#0ea5e9' } },
    ],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
